import axios from 'axios'
import { deviceUrl, baseUrl, tokenUrl, cautionUrl, metricUrl } from '@/api/config'
const actuatorInfo = '/actuator/info'
const actuatorHealth = '/actuator/health'

export function apiUrlinfo(params) {
  const url = 'api/actuator/info'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function apiUrlHealth(params) {
  const url = 'api/actuator/health'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function tokenUrlinfo(params) {
  const url = tokenUrl + actuatorInfo
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function tokenUrlHealth(params) {
  const url = tokenUrl + actuatorInfo
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function deviceUrlinfo(params) {
  const url = deviceUrl + actuatorInfo

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function deviceUrlHealth(params) {
  const url = deviceUrl + actuatorHealth

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function baseUrlinfo(params) {
  const url = baseUrl + actuatorInfo
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function baseUrlHealth(params) {
  const url = baseUrl + actuatorInfo
  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function cautionUrlinfo(params) {
  const url = cautionUrl + actuatorInfo

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function cautionUrlHealth(params) {
  const url = cautionUrl + actuatorHealth

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function metricUrlinfo(params) {
  const url = metricUrl + actuatorInfo

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

export function metricUrlHealth(params) {
  const url = metricUrl + actuatorHealth

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
